__turbopack_context__.v({
  "arrow": "ReferredList-module__UAT6XW__arrow",
  "referred": "ReferredList-module__UAT6XW__referred",
  "referred__button": "ReferredList-module__UAT6XW__referred__button",
  "referred__link": "ReferredList-module__UAT6XW__referred__link",
  "referred__list": "ReferredList-module__UAT6XW__referred__list",
  "referred__title": "ReferredList-module__UAT6XW__referred__title",
});
